(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bak"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.initDetailsEvent();
    }

    initDetailsEvent(){
      this.detailsList = this.querySelectorAll("details.mega-menu");
      this.detailsList.forEach((details) => {
        details.style.setProperty("--offset-left", details.querySelector("summary").getBoundingClientRect().left - 20 + "px");
        // details.addEventListener("toggle", () => {
        //   if(details.open){
        //     details.style.setProperty("--offset-left", details.querySelector("summary").getBoundingClientRect().left + "px");
        //   }
        // });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.initDetailsEvent();

      window.addEventListener('resize', this.initDetailsEvent.bind(this));
    }

    initDetailsEvent(){
      this.detailsList = this.querySelectorAll("details.mega-menu");
      this.detailsList.forEach((details) => {
        const summary = details.querySelector("summary");
        const summaryRect = summary.getBoundingClientRect();
        const viewportWidth = window.innerWidth - 15;
        const leftSpace = summaryRect.left;
        const rightSpace = viewportWidth - summaryRect.right;
        
        // 判断两边空间是否都不足990px
        if (leftSpace < 990 && rightSpace < 990) {
          // 居中显示
          const centerOffset = (viewportWidth - 990) / 2;
          details.style.setProperty("--offset-left", (centerOffset > 0 ? centerOffset : 0) + "px");
        } else {
          // 原有逻辑
          const isNearLeft = summaryRect.left < viewportWidth / 2;
          if (isNearLeft) {
            details.style.setProperty("--offset-left", summaryRect.left - (viewportWidth > 1010 ? 20 : 0) + "px");
          } else {
            const offsetLeft = summaryRect.right - 990;
            details.style.setProperty("--offset-left", offsetLeft + "px");
          }
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-subnavigation"] && !Shopify.designMode) return;
  try {
    
  customElements.define("sub-navigation", class extends HTMLElement {
    constructor(){
      super();

      this.tabs = this.querySelectorAll(".subnavigation-tab");
      if(!this.tabs?.length) return;
      this.tabs.forEach(tab => {
        // hide inactive section
        const targetId = tab.dataset.target;
        if(!tab.classList.contains("active")){
          const target = document.querySelector(`[data-subnavigation-target=${targetId}].pdp-subnavigation-item`);
          
          if(target) {
            // There is margin between sections, so we need to hide the section
            const targetSection = target.closest(".shopify-section");
            targetSection.style.display = "none";
          }
        }

        tab.addEventListener("click", (event) => {
          let tabTarget = null
          this.tabs.forEach(item => item.classList.remove("active"));
          tab.classList.add("active");

          this.hideAllTargets()
          // console.log('tab', tab)

          if(tab.dataset.target){
            try{
              tabTarget = document.querySelector(`[data-subnavigation-target=${tab.dataset.target}].pdp-subnavigation-item`) || null;
            }catch(e){
              console.error(e);
            }
          }
          if(tabTarget){
            this.showTarget(tabTarget);
          }
        });
      });
    }

    // show target section
    showTarget(target){
      if(!target) return;
      const targetSection = target.closest(".shopify-section");
      targetSection.style.display = "block";
    }
    // hide other target sections
    hideAllTargets(){
      const targets = document.querySelectorAll(".pdp-subnavigation-item");
      targets.forEach(item => {
        const targetSection = item.closest(".shopify-section");
        if(!targetSection) return;
        targetSection.style.display = "none";
      });
    }
    // scroll to target section
    // scrollToTarget(target){
    //   const targetTop = target.getBoundingClientRect().top;
    //   const scrollTop = window.scrollY;
    //   const targetOffset = targetTop + scrollTop - 60;
    //   window.scrollTo({ top: targetOffset, behavior: 'smooth' });
    // }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
customElements.define("custom-tab", class extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('.section--tabs .tab-item');
        this.tabs.forEach(tab => {
            tab.addEventListener('click', this.tabClick.bind(this, tab));
        });
        this.hideAllTargets();  
        const activeTab = this.querySelector('.tab-item.active');

        this.tabClick.call(this, activeTab)
    }

    tabClick(tab) {
      this.tabs.forEach(tab => tab.classList.remove('active'));
      tab.classList.add('active');
      const tabId = tab.getAttribute('data-tab-id');

      if (!tabId) return;
      
      const content = document.querySelector(`[data-tab-target=${tabId}].tab-section-target`);
      // console.log('content', content,`.tab-section-target[data-tab-target=${tabId}]`)
      if (content) {
        this.hideAllTargets()
        const targetSection = content.closest(".shopify-section");
        if (targetSection) {
          targetSection.style.display = "block";
        }
      }
    }

    hideAllTargets(){
      const targets = document.querySelectorAll(".tab-section-target");
      targets.forEach(item => {
        const targetSection = item.closest(".shopify-section");
        if(!targetSection) return;
        targetSection.style.display = "none";
      });
    }
})


  } catch(e) { console.error(e); }
})();
})();
